module.exports = __webpack_public_path__ + "static/img/sequence-neon.12edae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-neon.png
// module id = 675
// module chunks = 64